import {Injectable} from '@angular/core';
import {HttpService} from '@core/backend/common/api/http.service';
import {Observable} from 'rxjs';
import {SubgroupChangeOrderDto} from '@core/interfaces/engin/mobile-admin/group-inspection-values';

@Injectable()
export class GroupInspectionValuesApi {
    private readonly prefix = 'mobile/group-inspection-values';

    constructor(private api: HttpService) {}

    public deleteSubGroupInspection(subgroupId: number): Observable<void> {
        return this.api.delete(`${this.prefix}/${subgroupId}`);
    }
    public changeSubgroupContentOrder(subgroupId: number, reqBody: SubgroupChangeOrderDto): Observable<void> {
        return this.api.put(`${this.prefix}/${subgroupId}/change-order`, reqBody);
    }
}
